import { FC, PropsWithChildren } from "react";
import { Footer } from "./components";
import { ModalProvider } from "components/modal";

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <ModalProvider />
      <div className="d-flex flex-column min-vh-100 vh-100">
        <main className="container-fluid pos-relative d-flex flex-column px-0 flex-grow-1">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
};
